import { get } from 'lodash';
import * as React from 'react';
import { gamification } from '../../api/event';
import { nonPiletInstances, PILET_NAMES } from '../../configs/config';
import { STORAGE_KEYS } from '../../Utils/constants';
import { getItem } from '../../Utils/Storage';
import { parseQueryParams } from '../../Utils/utils';
import { Loading } from '../UI/loading';
import { getTraderAuthData, getTraderRealmData } from './trader.utils';

const TraderUI = () => {
  const [d, setD] = React.useState({
    isLoading: true
  });

  const hideLoading = () => {
    setD({
      ...d,
      isLoading: false
    });
  };

  const pathname = location.pathname;
  const [, , nextScreen] = pathname.split('/');
  const [traderAppConfig]: any = nonPiletInstances.filter(
    ({ appName }) => appName === PILET_NAMES.TRADERUI
  );
  const url = traderAppConfig.url;

  const isStorageAppLoadFromSet = React.useRef(false);
  const isStorageAuthDataSet = React.useRef(false);
  const frame: any = document.getElementsByTagName('iframe');
  let frameAuthData = {};
  const dashboardData = localStorage.getItem('DASHBOARD_DATA');

  try {
    let authData = JSON.parse(localStorage['AUTH_CONFIG']);
    let realmData = authData.realms[0];
    frameAuthData = { ...authData };
  } catch (e) {
    console.error('failed to parsed fintech data', e);
  }
  try {
    const parsedDashboardData = JSON.parse(dashboardData);
    frameAuthData = {
      authData: JSON.stringify(frameAuthData),
      dashboardData: parsedDashboardData,
      env: 'agnet'
    };
  } catch (e) {
    console.error('error parsing dashboarddata', e);
  }

  React.useEffect(() => {
    window.addEventListener('message', (event) => {
      const action = get(event, 'data.action', '');
      const [loans] = frame;

      if (action === 'get_auth_detail') {
        const params = parseQueryParams(get(location, 'search', {}));
        const to = get(params, 'navigate', undefined);
        const data = get(params, 'data', undefined);

        if (loans.contentWindow) {
          if (!isStorageAuthDataSet.current) {
            loans.contentWindow.postMessage(
              {
                action: 'set_auth_detail',
                value: {
                  authData: getTraderAuthData(decodeURI(data)),
                  realmOwnerData: getTraderRealmData(decodeURI(data)),
                  from: 'container',
                  to
                }
              },
              '*'
            );
            isStorageAuthDataSet.current = true;
          }
        }
      }
      if (action === 'get_custom_domain') {
        gamification({
          name: `OPEN_${PILET_NAMES.TRADERUI}`,
          type: 'OPEN_APP'
        });
        const params = parseQueryParams(get(location, 'search', {}));
        const to = get(params, 'navigate', undefined);
        if (loans.contentWindow) {
          const storageDomain = getItem(STORAGE_KEYS.CUSTOM_DOMAIN);
          if (storageDomain) {
            loans.contentWindow.postMessage(
              {
                action: 'set_custom_domain',
                value: {
                  customDomain: storageDomain,
                  from: 'container',
                  to
                }
              },
              '*'
            );
            isStorageAppLoadFromSet.current = true;
          }
        }
      }
      if (action === 'close_trader_app') {
        history.pushState('', '', nextScreen ? `/${nextScreen}` : '/');
        const popStateEvent = new PopStateEvent('popstate', {});
        dispatchEvent(popStateEvent);
        gamification({
          name: `CLOSE_${PILET_NAMES.TRADERUI}`,
          type: 'CLOSE_APP'
        });
      }
    });
  }, []);
  return (
    <div className='w-screen h-screen'>
      {d.isLoading && <Loading />}
      <iframe className='w-full h-full' onLoad={hideLoading} src={url}></iframe>
    </div>
  );
};

export default TraderUI;
